import React from 'react';
import PropTypes from 'prop-types';

import { DragDropContext } from 'react-beautiful-dnd';
import { Backlog, Sprint } from '..';

const DragDropArea = ({
  onDragEnd, sprints, isProjectCompleted, getTasks,
}) => (
  <div className="table-tasks">
    <DragDropContext onDragEnd={onDragEnd}>
      {sprints.map(item => (<Sprint isProjectCompleted={isProjectCompleted} key={`sprint-key-${item}`} id={item} />))}
      <Backlog isProjectCompleted={isProjectCompleted} getTasks={getTasks} />
    </DragDropContext>
  </div>
);

DragDropArea.propTypes = {
  sprints: PropTypes.arrayOf(PropTypes.number),
  onDragEnd: PropTypes.func.isRequired,
  getTasks: PropTypes.func.isRequired,
};

DragDropArea.defaultProps = {
  sprints: [],
};


export default DragDropArea;
